<template>
    <div v-if="json" class="block-digital-first">
        <div
            class="bgimg parallax-hook"
            :style="`background-image:url('${window.config.json.artifacts.digitalFirstBg}')`"
        ></div>
        <div class="capper">
            <div class="capper-padded">
                <div class="items">
                    <div class="items-l">
                        <h2 v-html="formatMainLabel(json.digitalFirstTitle)"></h2>
                    </div>
                    <div class="items-r">
                        <div class="caption" v-html="formatMainLabel(json.caption2)"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import gsap from '@/plugins/gsap'
import gh from '@/helpers/gh'

export default {
    name: "DigitalFirst",
    props: {
        json: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            window: window,
            gh: gh,
        }
    },
    mounted() {
        this.initSetup();

        // Use an IntersectionObserver to trigger the animation when 35% of the component is visible
        const observerOptions = { threshold: 0.45 };
        const observer = new IntersectionObserver((entries, obs) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    this.animate();
                    obs.disconnect();
                }
            });
        }, observerOptions);
        observer.observe(this.$el);
    },
    methods: {
        // Split the text into DIVs (one for each line)
        formatMainLabel(str) {
            str = str.replace(/\n/g, "XXX");
            return str.split("XXX").map(part => `<div>${part}</div>`).join("");
        },
        // Set initial styles for h2 child DIVs and caption
        initSetup() {
            const h2 = this.$el.querySelector("h2");
            if (h2) {
                const divs = h2.querySelectorAll("div");
                divs.forEach(div => {
                    div.style.opacity = 0;
                    div.style.transform = "translateY(15px)";
                });
            }
            const caption = this.$el.querySelector(".caption");
            if (caption) {
                caption.style.opacity = 0;
                caption.style.transform = "translateY(15px)";
            }
        },
        // Animate the h2 DIVs and caption into view
        animate() {
            const timeline = gsap.timeline();

            // Animate each h2 child div
            const h2 = this.$el.querySelector("h2");
            if (h2) {
                const divs = h2.querySelectorAll("div");
                timeline.fromTo(
                    divs,
                    { opacity: 0, y: 15 },
                    {
                        opacity: 1,
                        y: 0,
                        duration: 0.75,
                        ease: "power2.out",
                        stagger: 0.1,
                    }
                );
            }

            // Animate the caption with a slight overlap
            const caption = this.$el.querySelector(".caption");
            if (caption) {
                timeline.fromTo(
                    caption,
                    { opacity: 0, y: 15 },
                    {
                        opacity: 1,
                        y: 0,
                        duration: 0.75,
                        ease: "power2.out",
                    },
                    "-=0.5"
                );
            }
        },
    }
};
</script>
